import { componentStyles, useTheme } from "@mallardbay/lib-react-components"

export function useSharedStyles({
    shouldAddBottomPadding,
}: { shouldAddBottomPadding?: boolean } = {}) {
    const { colors } = useTheme()

    return componentStyles({
        wrapper: {
            borderBottomWidth: "1px",
            borderBottomStyle: "solid",
            borderBottomColor: colors.borderOpaque,
            marginBottom: "24px",
            paddingBottom: shouldAddBottomPadding ? "12px" : undefined,
        },
        linkButton: {
            color: colors.text,
        },
    })
}
